<template>
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
        <p>Redirecting...</p>
    </div>
</template>

<script>
export default {
    created() {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        console.log("1. [Child] Facebook popup loaded. Code:", code);
        console.log("2. [Child] Opener exists?", !!window.opener);

        if (!code) {
            console.error("Code missing from URL");
        }

        if (window.opener) {
            console.log("3. [Child] Sending message to parent...");
            window.opener.postMessage(
                { type: "FACEBOOK_CODE_SUCCESS", code },
                "*"
            );

            // Give time for postMessage to complete
            setTimeout(() => {
                console.log("4. [Child] Closing popup...");
                window.close();
            }, 300);
        } else {
            console.warn("Popup has no opener. Cannot send message.");
        }
    }
};
</script>
